module.exports = __webpack_public_path__ + "static/media/f1.5b3ed4ee.jpg";